var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"19274bf4830029f29b6fc29ab09cc2292dbd10e2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["inbox-ui@capsim"]={id:"19274bf4830029f29b6fc29ab09cc2292dbd10e2"};
      